







































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import {
  PermissionNodeType,
  PermissionRule,
  PermissionRuleType
} from "@/@types/store";
import PermissionTypeSelect from "@/app/basic/common/components/select/PermissionTypeSelect.vue";
import PermissionNodeTypeSelect from "@/app/basic/common/components/select/PermissionNodeTypeSelect.vue";
import ActorGroupSelect from "@/app/basic/common/components/select/ActorGroupSelect.vue";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import ActorSelect from "@/app/basic/common/components/select/ActorSelect.vue";
import SCheck from "@/app/basic/common/components/SCheck.vue";
import { listToEmpty } from "@/app/core/utility/PrimaryDataUtility";

@Component({
  components: {
    SCheck,
    CtrlButton,
    ActorGroupSelect,
    ActorSelect,
    PermissionNodeTypeSelect,
    PermissionTypeSelect
  }
})
export default class ChmodRuleEditComponent extends Vue {
  @Prop({ type: Object, required: true })
  private permissionRule!: PermissionRule;

  private isMounted: boolean = false;

  private groupListInput: string[] = [];
  private actorListInput: string[] = [];
  private isUseOwner: boolean = false;

  public key: string = "ChmodRuleEditComponent";

  @LifeCycle
  private async mounted() {
    this.isMounted = true;

    listToEmpty(this.groupListInput);
    listToEmpty(this.actorListInput);
    this.permissionRule.list.forEach(pr => {
      if (pr.type === "owner") {
        this.isUseOwner = true;
        return;
      }
      let list: string[] = [];
      if (pr.type === "group") list = this.groupListInput;
      else if (pr.type === "actor") list = this.actorListInput;
      if (pr.id) list.push(pr.id);
    });
  }

  @Watch("permissionRule.type")
  private onChangePermissionType(type: PermissionRuleType) {
    if (type === "none") {
      listToEmpty(this.permissionRule.list);
      listToEmpty(this.groupListInput);
      listToEmpty(this.actorListInput);
      this.isUseOwner = false;
    }
  }

  @Watch("groupListInput", { deep: true })
  @Watch("actorListInput", { deep: true })
  @Watch("isUseOwner")
  private mergeInputList() {
    listToEmpty(this.permissionRule.list);
    const addList = (list: string[], type: PermissionNodeType) => {
      this.permissionRule.list.push(...list.map(id => ({ type, id })));
    };
    addList(this.groupListInput, "group");
    addList(this.actorListInput, "actor");
    if (this.isUseOwner) {
      this.permissionRule.list.push({
        type: "owner"
      });
    }
  }
}
